import { Navigate } from "react-router-dom";
import { get } from "../../utils/localStorage";

import { isEmpty as isStringEmpty } from "../../utils/string";

const ProtectedRoute = ({ token, redirectPath = "/", children }) => {
  if (isStringEmpty(get("token")) && isStringEmpty(get("refreshToken"))) {
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default ProtectedRoute;
